import "../../styles/layout.scss";
import { Chat } from "../Chat";
import { NotificationsList } from "../NotificationsList";
import { useRef, useState, useEffect } from "react";
import { useUnit } from "effector-react";
import { $pushNotifications } from "../../store/pushNotifications";
import { $chatMessages, $isAuth, $userData } from "../../store";
import { VerticalIconButton } from "../VerticalIconButton";
import { MenuElement } from "./MenuElement";
import { FloatingTabsPanel } from "../FloatingTabsPanel";
import { $unreadAnnouncementsCount } from "../../store";
import { CreditCardFilled, HomeFilled, MenuOutlined, MessageFilled } from "@ant-design/icons";
import { isMobile } from 'react-device-detect';
import { ReactComponent as Hammer } from "../../assets/hammer.svg";

export const Footer = () => {
    const [unreadMessages, setUnreadMessages] = useState({
        messages: 0,
        notifications: 0
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const buttonRef = useRef(null);

    const messages = useUnit($chatMessages);
    const userData = useUnit($userData);
    const isAuth = useUnit($isAuth);
    const pushNotifications = useUnit($pushNotifications);
    const unreadAnnouncementsCount = useUnit($unreadAnnouncementsCount);

    const pathname = window.location.pathname.split('/').pop();

    useEffect(() => {
        const unreadMessages = messages.filter(message => !message.read && message.senderId !== userData.id && message.recipientId === userData.id).length;
        const unreadNotifications = pushNotifications.filter(notification => !notification.isRead).length;
        setUnreadMessages({
            messages: unreadMessages,
            notifications: unreadNotifications
        });
    }, [messages, pushNotifications, userData]);

    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const goToMain = () => {
        window.location.href = '/';
    };

    const openPanel = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
            return;
        }

        setIsPanelOpen(true);
    };

    const goToCurrentBiddings = () => {
        window.location.href = "/currentBiddings";
    };

    const goToSubscriptionPay = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=/payment`;
            return;
        }
        window.location.href = `/payment`;
    }

    return (
        <div className="layout__footer">
            {isMobile && <>
                <div className="layout__footer__menu">
                    <VerticalIconButton
                        icon={<HomeFilled style={{ fontSize: '24px' }} />}
                        label="Главная"
                        onClick={goToMain}
                        badgeContent={unreadAnnouncementsCount}
                        active={pathname === ''} />
                    <VerticalIconButton
                        icon={<MessageFilled style={{ fontSize: '24px' }} />}
                        label="Чат"
                        badgeContent={unreadMessages.messages + unreadMessages.notifications}
                        onClick={() => openPanel()}
                        ref={buttonRef}
                    />

                    <VerticalIconButton icon={<Hammer width={"25px"} height={"25px"} />} label="Торги" onClick={goToCurrentBiddings} active={pathname === 'currentBiddings'} />
                    <VerticalIconButton icon={<CreditCardFilled style={{ fontSize: '24px' }} />} label="Оплата" onClick={goToSubscriptionPay} active={pathname === 'payment'} />
                    <VerticalIconButton icon={<MenuOutlined style={{ fontSize: '24px' }} />} label="Меню" onClick={openMenu} />
                    <MenuElement anchor={anchorEl} setAnchor={setAnchorEl} />
                </div>
                <FloatingTabsPanel
                    isOpen={isPanelOpen}
                    onClose={() => setIsPanelOpen(false)}
                    anchorEl={buttonRef.current}
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                    tabs={[
                        {
                            id: 'chat',
                            label: 'Чат',
                            icon: '💬',
                            component: Chat,
                            unreadCount: unreadMessages.messages
                        },
                        {
                            id: 'notifications',
                            label: 'Уведомления',
                            icon: '🔔',
                            component: NotificationsList,
                            unreadCount: unreadMessages.notifications
                        }
                    ]}
                />
            </>}
        </div>
    )
}